import { axios } from "@/plugins/axios";
import { getDataString } from "@/utils";

function getEbikeTrackerStatus(data = {}) {
    let dataString = getDataString(data);
    return axios.post(
        "?Mode=MeinServicebereich&Function=GetEbikeTrackerStatus",
        dataString
    );
}

function activateEbikeTracker(data = {}) {
    let dataString = getDataString(data);
    return axios.post(
        "?Mode=MeinServicebereich&Function=ActivateEbikeTracker",
        dataString
    );
}

export { getEbikeTrackerStatus, activateEbikeTracker };
